import cartoon from "../../images/our-services/logo.jpg";
import gore from "../../images/our-services/gore.jpg";

const teamsPictures = [
  {
    _id: "01",
    name: "Mr. Jacob Gore Samuel",
    image: gore,
    position: "FOUNDER & DIRECTOR",
    education:
      "PhD Candidate University of Juba (UoJ) Holder of two (2) Master’s Degrees from: University of Cavendish & Kampala University- UgandaB.A in Business Admin from Christian University- Uganda",
  },
  {
    _id: "02",
    name: "Mr. Wani Nun Wani",
    image: cartoon,
    position: "Inspector of Juba Proper Schools",

    education: ": B.A in Education from Open University of Sudan",
  },
  {
    _id: "03",
    name: "Mr. Emmanuel Jansuk",
    image: cartoon,
    position: "Principal of Juba Proper International College",

    education: "B.Sc Hon. Agriculture from University of Juba",
  },
  {
    _id: "04",
    name: "Mr. Majak Mangar Majak",
    image: cartoon,

    position: "Deputy Principal for Academic Affairs",
    education: "B.Sc Hon. Animal Sciences from University of Juba",
  },
  {
    _id: "05",
    name: "Mr. Nyambura James Gabriel",
    position: " Deputy Principal for Finance & Administration",
    education: "B.A in Human Resource Management from University of Juba",
    image: cartoon,
  },
  {
    _id: "06",

    image: cartoon,
    name: "Mr. Jurugo Innocent Vuni",
    position: "Director of Studies (DOS)",
    Education:
      " Bachelor Degree in Information Technology International University of East Africa- Uganda",
  },
  // tomorow here
  {
    _id: "07",

    image: cartoon,
    name: "Mr. Langi Gideon Longirim",
    position: "Secretary",
    education: "Diploma in Clinical Medicine- Juba Teaching Hospital",
  },
  {
    _id: "08",
    name: "Mr. Abraham Chol Mading",
    position: "Deputy Director of Studies",
    education: "Sudan School Certificate, Pursuing Bachelor Degree in UoJ",
    image: cartoon,
  },
  {
    _id: "09",
    Name: "Mr. Bokuru Geoffrey",
    position: "Deputy Secretary",
    education: "B.A in Education History and Religion",

    image: cartoon,
  },
  {
    _id: "10",
    name: "Mr. Abarimurenshi Silvani",
    position: "Head of Science- Class Teacher S3 & S4",
    education: "Diploma in Mathematics & Physics from Kabale NTC",
    image: cartoon,
  },
  {
    _id: "11",
    name: "Mr. Albesty Kur-Chok Mayek",
    position: "Head of Arts Department",
    education: "Student at the University of Juba (Dept. of Geo & Hist).",
    image: cartoon,
  },
  {
    _id: "12",
    Name: "Mrs. Lula Francis Assis",
    position: "Deputy Principal for Academic Affairs",
    education: "B.A Arts and Humanities from University of Juba",
    image: cartoon,
  },
  {
    _id: "13",
    name: "Mrs. Juan Esther George",
    position: "Teachers’ Wellfare",
    education: "B.A (Geo & Hist.) University of Bhar-El-Ghazal",

    image: cartoon,
  },
  {
    _id: "14",
    image: cartoon,
    name: "Mr. Opaka Sunday",
    position: "Teacher- CRE S3 & S4",
    education: "Bachelor Degree in Education from Gulu University",
  },
  {
    _id: "15",
    name: "Mr. Donti Berry",
    position: "Teacher",
    education: "UACE",

    image: cartoon,
  },
  {
    _id: "16",
    name: "Mr. Luke John Lutueri",
    position: "Commerce Teacher S3 & S4",
    education:
      "Diploma in Public Admin. Under Social Work & Social Admin From NIMSA Arua, Uganda",

    image: cartoon,
  },
  {
    _id: "17",
    name: "Mr. Ngarjok Majok Dor",
    position: "Chemistry Teacher",
    education:
      "Student at Upper Nile University, College of Medicine & Health Sciences",

    image: cartoon,
  },
  {
    _id: "18",
    name: "Mr. Alafi Wahid Richard",
    position: "Teacher",
    education: "UACE",

    image: cartoon,
  },
  {
    _id: "19",
    name: "Mr. Kepha Mongare Magwaga",
    position: "Teacher",
    education: "B.A in Education History Teacher & Kiswahili",

    image: cartoon,
  },
  {
    _id: "20",
    name: "Mr. Drichi Emmanuel Remis",
    position: " Maths Teacher S2",
    education:
      "B.A in Maths & Business Studies, Catholic University of South Sudan",
    image: cartoon,
  },
  {
    _id: "21",
    name: "Mr. Meja Loku Paul",
    position: "Teacher",
    education: " B.A in Business Administration",
    image: cartoon,
  },
  {
    _id: "22",
    name: "Mrs. Adeng Angella Malual",
    position: "Teacher",
    education: "B.A in Journalism & Communication- University of Juba",

    image: cartoon,
  },
  {
    _id: "23",
    name: "Mrs. Kiden Nancy Ruth",
    position: "D/SWT",
    education: "UACE",
  },
  {
    _id: "24",
    name: "Mr. Agin Isaac",
    position: "Biology Teacher S3 & S2",
    education: "UACE",
  },
  {
    _id: "25",
    name: "Mr. Mark Kumbo Baptist",
    position: "Teacher",
    education: "Certificate in Secondary Education",
  },
];

export default teamsPictures;
